var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BusinessCrud',{attrs:{"title":"PC视频中心","columns":_vm.columns,"search-fields":_vm.searchFields,"form-fields":_vm.formFields,"list-api":_vm.getPcVideoList,"save-api":_vm.savePcVideo,"delete-api":_vm.deletePcVideo,"defaults":{ source: '锐高', coverImage: '', sortOrder: 0, isTop: 0, viewCount: 0, status: 1 },"modal-width":860}})
}
var staticRenderFns = []

export { render, staticRenderFns }